import * as React from "react";
import { cn } from "@/lib/utils";
import { Button } from "./button";

interface KidCardProps {
  id: string | number;
  name: string;
  age?: number;
  ageGroup?: string;
  sessionsAttended?: number;
  upcomingSessions?: number;
  onViewDashboard: () => void;
  testIdPrefix?: string;
  className?: string;
}

export function KidCard({
  id,
  name,
  age,
  ageGroup,
  sessionsAttended,
  upcomingSessions,
  onViewDashboard,
  testIdPrefix,
  className,
}: KidCardProps) {
  const testId = testIdPrefix || `parent-kid-card-${id}`;

  return (
    <div
      className={cn(
        "bg-white border border-slate-200 rounded-2xl shadow-sm p-4 flex flex-col justify-between gap-3",
        className
      )}
      data-testid={testId}
    >
      {/* Top: Name and Age Group */}
      <div className="space-y-1">
        <h3 className="text-lg font-semibold text-slate-900" data-testid="kid-name">
          {name}
        </h3>
        <div className="text-sm text-slate-600">
          {age && <span data-testid="kid-age">Age {age}</span>}
          {age && ageGroup && <span> • </span>}
          {ageGroup && <span data-testid="kid-age-group">{ageGroup}</span>}
        </div>
      </div>

      {/* Middle: Metrics (if provided) */}
      {(sessionsAttended !== undefined || upcomingSessions !== undefined) && (
        <div className="space-y-2">
          {sessionsAttended !== undefined && (
            <div className="flex justify-between items-center">
              <span className="text-xs text-slate-600">Sessions attended:</span>
              <span className="text-sm font-semibold text-slate-900" data-testid="kid-sessions-attended">
                {sessionsAttended}
              </span>
            </div>
          )}
          {upcomingSessions !== undefined && (
            <div className="flex justify-between items-center">
              <span className="text-xs text-slate-600">Upcoming sessions:</span>
              <span className="text-sm font-semibold text-slate-900" data-testid="kid-upcoming-sessions">
                {upcomingSessions}
              </span>
            </div>
          )}
        </div>
      )}

      {/* Bottom: View Dashboard Button */}
      <Button
        onClick={onViewDashboard}
        className="w-full h-11 rounded-full text-sm font-semibold bg-emerald-600 hover:bg-emerald-700 text-white"
        data-testid="btn-view-dashboard"
      >
        View Dashboard
      </Button>
    </div>
  );
}
